const { getConfigFields } = require('./datasource-config-utils')

function getSecretFields(children) {
    return getConfigFields(children, { filterFn: (node) => node.type === 'secret' && node.bindingType === 'value' })
}

function getDsSecretFields(dataSource) {
    let secretFields = [];

    switch (dataSource.type) {
        case 'Credentials':
            secretFields = getSecretFields(dataSource.mapping.children);
            break;
        case 'StackContext':
            secretFields = getSecretFields(dataSource.inputs.children);
            break;
        case 'Notifications':
            secretFields = getSecretFields(dataSource.context.children);
            break;
        default:
            break;
    }

    return secretFields;
}

function clearSecretFields(children) {
    if (!children) {
        return;
    }

    children.map(node => {
        if (node.children) {
            clearSecretFields(node.children);
        } else if (node.type === 'secret' && node.bindingType === 'value') {
            node.value = null;
        }
    })
}

module.exports = { getSecretFields, getDsSecretFields, clearSecretFields }
